import service from '@/utils/axios';

//财教列表
export function investEduList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/investEdu/list',
        method: 'post',
        params: data
    })
}
//财教老师列表
export function ieTeacherList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/ieTeacher/list',
        method: 'post',
        params: data
    })
}
//视频列表
export function videoList(query) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/tjzx/video/list',
        method: 'get',
        params: query
    })
}
//专栏列表返回专栏下所有老师和视频
export function ieTeacherList2(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/ieTeacher/list2',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/education.js